export const FIELD_PLACEHOLDER = {
    SELECT: 'Select',
    SELECT_DATE: 'Select date',
    ADD: 'Add',
    EMPTY: '-',
} as const;

// Data value of the "nothing selected" option; FIELD_PLACEHOLDER.EMPTY is only the display glyph.
export const EMPTY_OPTION_VALUE = '-';

export const FIELD_CARET_SIZE = { HEIGHT: '8', WIDTH: '14' } as const;

// aria-haspopup value for triggers that open an option menu.
export const FIELD_MENU_POPUP = 'listbox';
